var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "total-footer" }, [_c('div', { staticClass: "total-footer-text" }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.payment.grantDialog.totalFooter.price')) + "\n  ")]), _vm._v(" "), _c('div', { staticClass: "total-footer-price" }, [_vm._v("\n    " + _vm._s(_vm.price.toLocaleString()) + " " + _vm._s(_vm.currency) + "\n  ")])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };